import { render, staticRenderFns } from "./scoreValue.vue?vue&type=template&id=5959a24d&scoped=true"
import script from "./scoreValue.vue?vue&type=script&lang=js"
export * from "./scoreValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5959a24d",
  null
  
)

export default component.exports